import { render, staticRenderFns } from "./updateFlightPriceModal.vue?vue&type=template&id=a10a7890&scoped=true&"
import script from "./updateFlightPriceModal.vue?vue&type=script&lang=ts&"
export * from "./updateFlightPriceModal.vue?vue&type=script&lang=ts&"
import style0 from "./updateFlightPriceModal.vue?vue&type=style&index=0&id=a10a7890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10a7890",
  null
  
)

export default component.exports